/**
 * Форматування дат сповіщень (Notification.dateEntered / dateSend) з примусовою
 * прив'язкою до Europe/Kyiv — щоб час не "плив" за системним часовим поясом пристрою,
 * на якому відкрита адмінка.
 */

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
import timezone from 'dayjs/plugin/timezone.js';

dayjs.extend(utc);
dayjs.extend(timezone);

const PLACEHOLDER = 'дд.мм.рррр --:--';
const FORMAT = 'DD.MM.YYYY HH:mm';
const OFFSET_REGEX = /([+-]\d{2}):(\d{2})$/;

export const formatNotificationDate = (date) =>
	date ? dayjs(date).tz('Europe/Kyiv').format(FORMAT) : PLACEHOLDER;

/**
 * КОСТИЛЬ: на бекенді `dateSend` серіалізується з офсетом (напр. "+03:00"),
 * але сам час у полі фактично не зсунутий на цей офсет — це "сирий" час
 * без конвертації, з чужим суфіксом (порівняй: dateEntered "17:00:12+03:00"
 * і dateSend "14:03:02+03:00" того самого сповіщення — надсилання нібито
 * відбулось РАНІШЕ за створення, що неможливо; реальний час надсилання —
 * "сирі" digits + сам офсет, тобто 14:03:02 + 3:00 = 17:03:02).
 *
 * Тому тут офсет не віднімається (як в звичайній ISO-конвертації), а додається
 * до "наївного" (без офсету) часу з рядка.
 *
 * TODO [API]: виправити на бекенді генерацію/серіалізацію `dateSend`
 * (`api/src/Service/NotificationService.php` / `api/src/Controller/NotificationController.php`,
 * виклики `setDateSend(new \DateTime())`), щоб офсет відповідав реальному зсуву часу.
 * Після виправлення на бекенді — прибрати цю функцію і викликати всюди
 * звичайну `formatNotificationDate(date)`, як для `dateEntered`.
 */
export const formatNotificationDateSend = (date) => {
	if (!date) return PLACEHOLDER;

	const offsetMatch = OFFSET_REGEX.exec(date);
	if (!offsetMatch) return formatNotificationDate(date);

	const offsetSign = offsetMatch[1].startsWith('-') ? -1 : 1;
	const offsetHours = Math.abs(parseInt(offsetMatch[1], 10));
	const offsetMinutesPart = parseInt(offsetMatch[2], 10);
	const offsetMinutes = offsetSign * (offsetHours * 60 + offsetMinutesPart);

	const naiveDate = date.replace(OFFSET_REGEX, '');
	return dayjs.utc(naiveDate).add(offsetMinutes, 'minute').format(FORMAT);
};
